import { Component, Input } from "@angular/core";
import { Actionnaire } from "../../../interfaces/Actionnaire";

@Component({
  selector: "app-banque",
  templateUrl: "./banque.component.html",
  standalone: false,
})
export class BanqueComponent {
  @Input() actionnaire: Actionnaire;
}
